export default __webpack_public_path__ + "static/media/advantageIcon3.80b6faee.webp";